import { tooltipType } from '@AMIEWEB/Common/Tooltips';
import { ICandidateDetails } from 'app/models/Candidate/CandidateProfile';
import { ILookupState } from 'store/redux-store/lookup/initialState';

export const buildInterviewInvitePayload = (
  data: { discipline: string; specialty: string; reason: string },
  lookupData: ILookupState,
  interviewReasons: { value: any; name: string }[],
  candidateDetails: ICandidateDetails,
  userInfo: { employeeId?: number; firstName?: string; lastName?: string } | undefined,
) => {
  const discipline = lookupData.disciplines.find(item => item.object.Description === data.discipline);
  const specialty = lookupData.specialties.find(item => item.object.Description === data.specialty);
  const reason = interviewReasons.find(item => item.name === data.reason);
  return {
    candidateId: candidateDetails.travelerId,
    disciplineId: discipline?.object.ID,
    specialtyId: specialty?.object.SpecialtyID,
    reasonId: reason?.value,
    reason: reason?.name,
    candidateName: {
      prefix: candidateDetails.name.prefix,
      first: candidateDetails.name.first,
      middle: candidateDetails.name.middle,
      last: candidateDetails.name.last,
      goesBy: candidateDetails.goesBy,
      other: candidateDetails.other,
    },
    primaryPhoneNumber: candidateDetails.primaryPhoneNumber,
    mobilePhoneNumber: candidateDetails.mobilePhoneNumber,
    primaryEmail: candidateDetails.primaryEmail,
    secondaryEmail: candidateDetails.secondaryEmail,
    recruiter: {
      recruiterId: candidateDetails.recruiter.recruiterId,
      first: candidateDetails.recruiter.first,
      last: candidateDetails.recruiter.last,
      email: candidateDetails.recruiter.email,
    },
    currentEmployeeId: userInfo?.employeeId,
    currentEmployeeName: `${userInfo?.firstName} ${userInfo?.lastName}`,
  };
};

export const getEmploymentHistoryHeaders = () => [
  {
    value: 'Field Changed',
    title: 'fieldChanged',
  },
  {
    value: 'Old Value',
    title: 'oldValue',
    tooltip: tooltipType.OverflowTooltip,
    toolTipRowContentStyle: { color: 'black', fontSize: '14px', fontWeight: 'normal' },
  },
  {
    value: 'New Value',
    title: 'newValue',
    tooltip: tooltipType.OverflowTooltip,
    toolTipRowContentStyle: { color: 'black', fontSize: '14px', fontWeight: 'normal' },
  },
  { value: 'Changed By', title: 'changedBy' },
  { value: 'Date / Time', title: 'date' },
];
